var React = require('react');

function ExistingCompany (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36.1448 26.3253V32.4217M2.61426 41.6274V47.8519C2.61426 51.2201 5.34242 53.9483 8.71071 53.9483H17.8554M2.61426 17.2416V11.1451C2.61426 7.77681 5.34242 5.04864 8.71071 5.04864H17.8554M2.61426 29.4345H17.8554M17.8554 29.4345L11.7589 35.5309M17.8554 29.4345L11.7589 23.338M33.5934 56.8685L47.1397 53.8569C49.621 53.3082 51.3859 51.1074 51.3859 48.5682V10.4318C51.3859 7.89264 49.621 5.69182 47.1428 5.14314L33.5964 2.13149C30.2099 1.37858 27.0001 3.95433 27.0001 7.42321V51.5798C27.0001 55.0457 30.2099 57.6214 33.5934 56.8685Z","stroke":"#CE445B","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ExistingCompany.defaultProps = {"width":"54","height":"59","viewBox":"0 0 54 59","fill":"none"};

module.exports = ExistingCompany;

ExistingCompany.default = ExistingCompany;
